<p class="anim-date" *ngIf="tchekcompany && showDate"
  [ngClass]="{'date-top-right':!compareMode, 'date-centered':compareMode}">
  {{date | date:'short':'':'fr'}}
  {{tchekcompany ? tchekcompany : '' }}
</p>

<canvas #canvas{{canvasId}} id="htmlCanvas{{canvasId}}"></canvas>

<!-- HTML5 Video -->
<video #video id="video{{canvasId}}" hidden style="position: absolute; right: 0;" src=""
  crossorigin="anonymous"></video>


// WEBPACK FOOTER //
// ./src/app/element/canvas/canvas.component.html